<template>
    <div>
        <Head title="Revenue Share -Create"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" href="/revenue-share">Revenue Share</Link>
            <span class="text-indigo-400 font-medium">/</span> Create
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <select-input v-model="form.project" :error="form.errors.project"
                                  class="pb-8 pr-6 w-full lg:w-1/2" label="Project">
                        <option v-for="project in projects" v-bind:value="project.id">
                            {{ project.name }}
                        </option>
                    </select-input>
                    <text-input v-model="form.organization_share" :error="form.errors.organization_share"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Organization Share"/>
                    <text-input v-model="client_share" :error="form.errors.client_share"
                                class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Client Share" aria-readonly="true"/>

                    <small>use decimal place max eg 0.6</small>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">Create
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
    },
    props: {
        projects: Array,
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                project: '',
                organization_share: '',
                client_share: '',

            }),
        }
    },
    methods: {
        store() {
            this.form.post('/revenue-share')
        },
    },
    computed: {
        client_share: {
            get() {
                return (1 - this.form.organization_share).toFixed(1);
            }
        }
    }
}
</script>
